<template>
    <div class="speeding-info">
        <span class="speeding-info__level--red">Speeding</span><br />
        <strong>Start:</strong> {{ formatDate(speedPoint.startTime) }}<br />
        <strong>End:</strong> {{ formatDate(speedPoint.endTime) }}<br />
        <strong>Duration:</strong> {{ duration }}<br />
        <strong>Speed:</strong> {{ formatSpeedUnit }}<br />
        <strong>Speed Limit:</strong> {{ formatSpeedLimitUnit }}<br />
    </div>
</template>

<script>
import { calculateSpeedOrDistanceUnit, formatDate } from '@/helpers/Utils'
import moment from 'moment'

export default {
    name: 'SpeedingInfoBubble',
    props: {
        speedPoint: {
            type: Object,
            required: true
        },
        getSpeedUnit: {
            type: Number,
            required: true
        }
    },
    computed: {
        duration: function () {
            if (!this.speedPoint.endTime) return 'Unknown'

            const start = moment(this.speedPoint.startTime)
            const end = moment(this.speedPoint.endTime)
            return moment.utc(moment(end, 'HH:mm:ss').diff(moment(start, 'HH:mm:ss'))).format('HH:mm:ss')
        },
        formatSpeedUnit () {
            return 0 === this.getSpeedUnit ? this.speedPoint.speed + ' kph' : calculateSpeedOrDistanceUnit(this.speedPoint.speed, 'mi') + ' mph'
        },
        formatSpeedLimitUnit () {
            return 0 === this.getSpeedUnit ? this.speedPoint.speedLimit + ' kph' : calculateSpeedOrDistanceUnit(this.speedPoint.speedLimit, 'mi') + ' mph'
        }
    },
    methods: {
        formatDate (date) {
            return formatDate(date)
        }
    }
}
</script>

<style scoped lang="scss">
.speeding-info {
    padding: 10px 20px;
    min-width: 260px;

    &__level {
        font-weight: bold;

        &--red {
            color: #eb7375;
        }
    }
}

</style>
